import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./Comment.module.sass";
import Card from "../../../../components/Card";
import Editor from "../../../../components/Editor";
import { updateSessionFormation } from "../../../../services/sessions.service";
import { showSuccess, showError } from "../../../../services/toast.service";
import { EditorState, ContentState, convertToRaw, convertFromRaw } from 'draft-js';

const Comment = ({ className, session }) => {
    const [content, setContent] = useState(() => {
        const contentState = ContentState.createFromText('');
        return EditorState.createWithContent(contentState);
    });
    const [saving, setSaving] = useState(false);

    // Charger le commentaire existant de la session
    useEffect(() => {
        if (session?.description) {
            try {
                // Essayer de parser le JSON (format text enrichi)
                const rawContent = JSON.parse(session.description);
                const contentState = convertFromRaw(rawContent);
                setContent(EditorState.createWithContent(contentState));
            } catch (error) {
                // Si ce n'est pas du JSON, traiter comme du texte simple
                const contentState = ContentState.createFromText(session.description);
                setContent(EditorState.createWithContent(contentState));
            }
        }
    }, [session]);

    // Fonction pour sauvegarder le commentaire
    const handleSaveComment = async () => {
        if (!session?.id) return;

        setSaving(true);
        try {
            // Convertir le contenu de l'éditeur au format JSON pour PocketBase
            const contentState = content.getCurrentContent();
            const rawContent = convertToRaw(contentState);
            
            await updateSessionFormation(session.id, {
                description: JSON.stringify(rawContent)
            });
            showSuccess("Commentaire sauvegardé avec succès");
        } catch (error) {
            console.error("Erreur lors de la sauvegarde du commentaire:", error);
            showError("Erreur lors de la sauvegarde du commentaire");
        } finally {
            setSaving(false);
        }
    };

    const handleManualSave = () => {
        handleSaveComment(content);
    };

    return (
        <Card
            className={cn(styles.card, className)}
            title={`Commentaire ${saving ? "(Sauvegarde...)" : ""}`}
            classTitle="title-red"
        >
            <Editor
                state={content}
                onChange={setContent}
                classEditor={styles.editor}
                label="Commentaire de la session"
                tooltip="Ajoutez un commentaire pour cette session"
                placeholder="Ajoutez vos commentaires sur cette session..."
            />
            
            <div className={styles.actions} style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                <button
                    className="button-green"
                    onClick={handleSaveComment}
                    disabled={saving}
                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                    {saving ? 'Sauvegarde en cours...' : 'Sauvegarder'}
                    {saving && <div className="spinner-small" />}
                </button>
            </div>
        </Card>
    );
};

export default Comment;
